import { createSelector } from 'reselect';
import {
  BackendPager,
  Event,
  EventsPeriod,
  EventsWithPagerSelector,
  FormattedErrors,
} from 'type';
import { StoreState } from '../../types';
import { Moment } from 'moment';
import {
  DetailsModal,
  EventsFilters,
  EventsFiltersStatuses,
  SortEventsList,
} from './types';
import { GetEventsRequest } from 'lib/Api/type';

export const getErrors = (state: StoreState): FormattedErrors =>
  state.employeeDashboard.events.errors;
export const getPager = (state: StoreState): BackendPager =>
  state.employeeDashboard.events.pager;
export const getFiltersForm = (state: StoreState): EventsFilters =>
  state.employeeDashboard.events.filtersForm;
export const getFilters = (state: StoreState): EventsFilters =>
  state.employeeDashboard.events.filters;
export const getFiltersStatuses = (state: StoreState): EventsFiltersStatuses =>
  state.employeeDashboard.events.filters.statuses;
export const getFiltersStart = (state: StoreState): Moment | null =>
  state.employeeDashboard.events.filters.start;
export const getFiltersEnd = (state: StoreState): Moment | null =>
  state.employeeDashboard.events.filters.end;
export const getFiltersSort = (state: StoreState): SortEventsList =>
  state.employeeDashboard.events.filters.sort;
export const getEventsList = (state: StoreState): Event[] =>
  state.employeeDashboard.events.events;
export const getSelectedPeriod = (state: StoreState): EventsPeriod =>
  state.employeeDashboard.events.period;
export const getDetailsModal = (state: StoreState): DetailsModal =>
  state.employeeDashboard.events.detailsModal;

export const eventsWithPagerSelector = createSelector<
  StoreState,
  Event[],
  BackendPager,
  EventsWithPagerSelector
>(getEventsList, getPager, (page, pager) => ({
  page,
  ...pager
}));

export const payloadSelector = createSelector<
  StoreState,
  BackendPager,
  EventsFiltersStatuses,
  Moment | null,
  Moment | null,
  SortEventsList,
  GetEventsRequest
>(
  getPager,
  getFiltersStatuses,
  getFiltersStart,
  getFiltersEnd,
  getFiltersSort,
  ({ currentPage, pageSize }, statuses, start, end, { column, direction }) => {
    return {
      page: currentPage,
      per_page: pageSize,
      start,
      end,
      statuses,
      order_by: column,
      order_dir: direction
    };
  }
);

export const isFiltersFormDisabledSelector = createSelector<
  StoreState,
  EventsFilters,
  boolean
  >(getFiltersForm, ({ statuses }) => !!statuses && !statuses.length);
